export interface NormalizedUser {
  id: number | null;
  tenant_id: number | null;
  role_id: number | null;
  tenant_name?: string | null;
  role_name?: string | null;
  role?: any;
  tenant?: any;
  last_access_at?: string | null;
  [key: string]: any;
}

function coerceNumber(value: any): number | null {
  if (value === undefined || value === null || value === '') {
    return null;
  }
  const num = Number(value);
  return Number.isNaN(num) ? null : num;
}

export function normalizeUser(user: any): NormalizedUser | null {
  if (!user) {
    return null;
  }

  const tenant = user.tenant || {};
  const role = user.role || {};

  const normalized: NormalizedUser = {
    ...user,
    id: coerceNumber(user.id ?? user.user_id ?? user.uid),
    tenant_id: coerceNumber(user.tenant_id ?? user.tenantId ?? tenant.id ?? tenant.tenant_id),
    role_id: coerceNumber(user.role_id ?? user.roleId ?? role.id),
    tenant_name: user.tenant_name ?? tenant.name ?? tenant.tenant_name ?? null,
    role_name: user.role_name ?? role.role_name ?? role.name ?? null,
    last_access_at: user.last_access_at ?? user.lastAccessAt ?? null,
    tenant,
    role
  };

  return normalized;
}

export function storeUserSession(user: any): NormalizedUser | null {
  const normalized = normalizeUser(user);
  if (!normalized) {
    return null;
  }
  try {
    const serialized = JSON.stringify(normalized);
    sessionStorage.setItem('user', serialized);
    localStorage.setItem('user', serialized);
  } catch (_) {}
  return normalized;
}

export function loadStoredUser(): NormalizedUser | null {
  const stored = sessionStorage.getItem('user') || localStorage.getItem('user');
  if (!stored) {
    return null;
  }
  try {
    const parsed = JSON.parse(stored);
    return normalizeUser(parsed);
  } catch (_) {
    return null;
  }
}

export function updateStoredUser(partial: Partial<NormalizedUser>): NormalizedUser | null {
  const current = loadStoredUser();
  if (!current) {
    return null;
  }
  const merged = { ...current, ...partial };
  return storeUserSession(merged);
}
